import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <div className="flex min-h-screen flex-col bg-background">
    <Header />
    <main className="flex-1 pt-[115px]">{children}</main>
    <Footer />
  </div>
);

export default Layout;